/* בית, התקופה הנוכחית: כרטיס אחד שעונה על שלוש שאלות.
   כמה יש לי היום, כמה מותר לי להוציא היום, ומתי הנקודה המסוכנת הקרובה. כל השאר בלחיצה */
import { useState } from 'react';
import { S } from '../../domain/state.js';
import { fMoney, wD, todayISO } from '../../lib/format.js';
import { curKey, periodStart } from '../../domain/periods.js';
import { balEst, bankFreshness } from '../../domain/balance.js';
import { ls } from '../../store/ui.js';
import { openScan } from '../add/AddPage.jsx';
import { nextLow } from '../../domain/forecast.js';
import { safeToSpend, limitStatus } from '../../domain/plan.js';
import { saveLabel } from '../../domain/explain.js';
import { Xn, openWhy } from '../../components/ui.jsx';
import { navigate } from '../../app/nav.js';
import { Icon } from '../../components/Icon.jsx';
import { openAfford } from '../afford/Afford.jsx';
import { realisticToEnd } from '../../domain/afford.js';

export function HomeHero() {
  const bt = balEst(), now = bt.amount, s = safeToSpend(), low = nextLow(), R = realisticToEnd(), F = bankFreshness();
  const lim = Number(S.set.odLimit) || 0, st = limitStatus(low.balance);
  const col = st.st === 'bad' ? 'var(--red)' : st.st === 'warn' ? 'var(--gold)' : 'var(--green)';
  const pctLow = lim && low.balance < 0 ? Math.round((-low.balance / lim) * 100) : 0;
  const today = low.idx < 0;
  return (
    <div className="today">
      <div className="today-sec">
        <div className="today-k">בחשבון היום{F.stale ? ' (הערכה)' : ''}</div>
        <div className="today-v" style={{ color: now < 0 ? 'var(--red)' : 'var(--ink)' }}><Xn k="bal">{fMoney(now)}</Xn></div>
        {F.stale ? (
          <div className="today-pace warn">
            <b>אין נתוני עו"ש מאז {wD(F.last)} ({F.days} ימים).</b> המספר הוא היתרה של אז
            {bt.late.length > 0 && <>, ועוד <Xn k="bal">{fMoney(bt.lateSum, bt.lateSum > 0 ? '+' : '')}</Xn> מהכנסות וחיובים קבועים שהנחנו שקרו מאז</>}.
            {' '}כל המספרים כאן מבוססים עליו.
            <div className="row mt6" style={{ gap: 6 }}>
              <button className="ubtn ubtn-primary btn-sm" onClick={() => { ls.set('set_open', 'bal'); navigate('Set'); }}>עדכון יתרה</button>
              <button className="ubtn ubtn-outline btn-sm" onClick={openScan}>סריקת עו"ש</button>
            </div>
          </div>
        ) : bt.late.length > 0 && (
          <button className="today-s link-muted" onClick={() => openWhy('bal')}>
            כולל {fMoney(bt.lateSum, bt.lateSum > 0 ? '+' : '')} מתנועות קבועות שהמועד שלהן עבר ועוד לא נסרקו
          </button>
        )}
      </div>
      {s && <SpendSec s={s} />}
      <div className="today-sec">
        <div className="today-k">{low.balance < 0 ? 'הכי נמוך' : 'הכי נמוך, וזה בסדר'} עד {wD(low.end)}</div>
        <div className="today-v sm" style={{ color: low.balance < 0 ? 'var(--red)' : 'var(--green)' }}><Xn k="low">{fMoney(low.balance)}</Xn></div>
        <div className="today-s">
          {today ? 'היום' : 'ב-' + wD(low.date) + (low.beforeIncome ? ', לפני שהמשכורת נכנסת' : '')}
          {pctLow > 0 && <> · <b style={{ color: col }}>{pctLow}% מהמסגרת</b></>}
        </div>
        {lim > 0 && low.balance < 0 && <div className="runway" style={{ margin: '8px 0 0' }}><i style={{ right: 0, width: Math.min(100, pctLow) + '%', background: col }} /></div>}
        {R && R.show && <div className="today-s">עם ההוצאות הרגילות: בערך <Xn k="low"><b style={{ color: R.low < 0 ? 'var(--red)' : 'var(--ink)' }}>{fMoney(Math.round(R.low / 100) * 100)}</b></Xn>{R.lowDate > new Date(todayISO() + 'T23:00:00') ? ' ב-' + wD(R.lowDate) : ''}</div>}
        {low.next && <div className="today-s red" style={{ fontWeight: 700 }}>ובתקופה הבאה עמוק יותר: <Xn k="flow_low" arg={low.nextDays}>{fMoney(low.next.balance)}</Xn> ב-{wD(low.next.date)}</div>}
        <button className="link mt6" style={{ fontSize: '.86rem' }} onClick={() => navigate('Flow')}>מה יורד ומתי ‹</button>
      </div>
    </div>
  );
}

/** הכפתור "אפשר לקנות את זה?" מתחת לכרטיס היום */
export function AffordButton() {
  if (!S.set.balDate) return null;
  return (
    <button className="afford-btn" onClick={() => openAfford()}>
      <span className="afford-ico">🛒</span>
      <span className="grow"><b>אפשר לקנות את זה?</b><span className="note">בודקים מה קנייה עושה לחשבון, לפני שקונים</span></span>
      <Icon name="chevL" size={18} />
    </button>
  );
}

function SpendSec({ s }) {
  const pd = Math.max(0, Math.floor(s.perDay / 10) * 10);
  let pace = null;
  if (s.usualRest != null) {
    const u = s.usualRest, fits = u <= Math.max(0, s.left);
    const cut = s.left > 0 ? Math.min(100, Math.round((1 - s.left / u) * 100)) : 100;
    pace = (
      <div className={'today-pace ' + (fits ? 'ok' : 'warn')}>
        {fits ? <>✓ בקצב הרגיל (כ-<Xn k="usual">{fMoney(Math.round(u / s.days / 10) * 10)}</Xn> ביום) יש מרווח</>
          : <>בקצב הרגיל לא מספיק. צריך להוציא <Xn k="realend">{cut}% פחות</Xn> מהרגיל</>}
      </div>
    );
  }
  return (
    <div className="today-sec">
      <div className="today-k">מותר להוציא היום</div>
      <div className="today-v" style={{ color: s.left > 0 ? 'var(--ink)' : 'var(--red)' }}><Xn k="perday">{fMoney(pd)}</Xn></div>
      <div className="today-s">
        {s.left > 0
          ? <>אוכל, דלק, קניות. נשארו <Xn k="left">{fMoney(Math.round(s.left))}</Xn> ל-{s.days} ימים, עד {wD(s.endDate)}</>
          : <b className="red">גם בלי הוצאות נוספות, התקופה תסתיים {fMoney(Math.abs(Math.round(s.left)))} מתחת ליעד</b>}
      </div>
      {pace}
      <SpendHow s={s} />
    </div>
  );
}

function SpendHow({ s }) {
  const [how, setHow] = useState(false);
  const ed = wD(s.endDate), ps0 = periodStart(curKey());
  const sg = (x) => { x = Math.round(x); return fMoney(x, x > 0 ? '+' : ''); };
  const Row = ({ k, v, b, wk }) => (
    <div className={'bal-row' + (b ? ' tot' : '')}><span>{k}</span><b dir="ltr">{wk ? <Xn k={wk}>{v}</Xn> : v}</b></div>
  );
  return (
    <>
      <button className="link-muted mt6" style={{ fontSize: '.86rem' }} onClick={() => setHow(!how)} aria-expanded={how}>
        {how ? 'הסתר' : 'איך זה מחושב?'} <Icon name="chevD" size={14} style={how ? { transform: 'rotate(180deg)' } : undefined} />
      </button>
      {how && (
        <div className="bal-rows" style={{ marginTop: 8 }}>
          <Row k={'פתיחת התקופה (' + wD(ps0) + ')'} v={sg(s.open)} wk="open" />
          {s.save ? <Row k={saveLabel(s)} v={fMoney(s.save, '+')} wk={s.saveAuto ? 'save_auto' : s.stage === 4 ? 'sav_left' : 'save'} /> : null}
          <Row k={s.save ? 'יעד לסוף התקופה' : 'יעד: לא לסיים גרוע מהפתיחה'} v={sg(s.goal)} wk="goal" />
          <Row k={'צפוי ב-' + ed + ', בלי הוצאות נוספות'} v={sg(s.end)} wk="end" />
          <Row k={s.left > 0 ? 'נשאר להוצאות שוטפות (' + s.days + ' ימים)' : 'חסר כדי להגיע ליעד'} v={sg(s.left)} b wk="left" />
        </div>
      )}
    </>
  );
}
